import { NgModule } from '@angular/core';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers

// Services metier
import { ConstructeurService } from './services/constructeur.service';

@NgModule({
	imports: [
	],
	providers: [
		ConstructeurService,
	],
	declarations: [
	],
	exports: [
	]
})
export class ConstructeurModule {
	constructor() { }
}